import React from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import '../App.css';

function HowItWorksPage() {
  return (
    <div className="App">
      <Navbar />
      <header className="App-header" style={{alignItems: 'center'}}>
        <div className="form-container hiw-wrapper" style={{alignItems: 'flex-start'}}>
          
          <h1 style={{textAlign: 'center', width: '100%', marginBottom: '40px', color: '#222'}}>
            How We Turn "Resumes" into <br/>
            <span style={{color: '#0052cc'}}>Reliable Hiring Data</span>
          </h1>

          {/* --- STEP 1 (UPDATED) --- */}
          <div className="hiw-step-card">
            <div className="hiw-step-number">1</div>
            <div className="step-content">
              <h3>The Gap Analysis</h3>
              <p>Most hiring mistakes stem from assumptions. Resumes list keywords, but they rarely prove depth. Our AI compares the candidate's stated experience against the hard requirements of your Job Description. We identify <strong>"Verification Gaps"</strong>—areas where the resume is vague—and generate targeted scenarios to prove actual competency.</p>
            </div>
          </div>

          {/* --- STEP 2 --- */}
          <div className="hiw-step-card">
            <div className="hiw-step-number">2</div>
            <div className="step-content">
              <h3>Precision Scenario Generation</h3>
              <p>LuxerAssess generates custom <strong>Real-World Scenarios</strong> based specifically on the gaps we found. Whether it's a React migration or a B2B sales email, we test for critical thinking and problem-solving, not just memorized trivia.</p>
            </div>
          </div>

          {/* --- STEP 3 --- */}
          <div className="hiw-step-card">
            <div className="hiw-step-number">3</div>
            <div className="step-content">
              <h3>Integrity & Fairness Monitoring</h3>
              <p>We protect the value of your assessment with our <strong>Behavioral Telemetry</strong> system. We don't invade privacy with cameras; instead, we monitor behavioral signals to ensure the candidate completes the work independently.</p>
              <ul style={{color: '#555', fontSize: '0.95rem', paddingLeft: '20px', lineHeight: '1.6'}}>
                <li><strong>Focus Tracking:</strong> Tracks if the candidate leaves the assessment environment.</li>
                <li><strong>Originality Check:</strong> Detects high-velocity pasting and AI-generated syntax.</li>
                <li><strong>Strict Timing:</strong> Simulates real-world pressure to prevent external assistance.</li>
              </ul>
            </div>
          </div>

          {/* --- STEP 4 --- */}
          <div className="hiw-step-card last">
            <div className="hiw-step-number">4</div>
            <div className="step-content">
              <h3>The Decision-Ready Report</h3>
              <p>You don't just get a score; you get a hiring recommendation. Our AI acts as a <strong>Technical Consultant</strong>, grading the submission against a hidden rubric to provide:</p>
              <ul style={{color: '#555', fontSize: '0.95rem', paddingLeft: '20px', lineHeight: '1.6'}}>
                <li><strong>The Luxer Fit Score:</strong> A weighted percentage of role suitability.</li>
                <li><strong>Reasoning Logs:</strong> Detailed explanations of why an answer was strong or weak.</li>
                <li><strong>Integrity Confidence:</strong> A clear signal on whether the results are trustworthy.</li>
              </ul>
            </div>
          </div>

          {/* --- CTA --- */}
          <div className="hiw-cta-card">
            <h2 style={{color: 'white', marginBottom: '15px', fontSize: '1.8rem'}}>Don't hire based on a guess.<br/>Hire based on data.</h2>
            <p style={{fontSize: '1.2rem', marginBottom: '25px', color: '#e6f0ff'}}>
                Join the agile recruiters moving away from subscriptions. <br/><strong>Your credits never expire.</strong>
            </p>
            
            <Link to="/signup" className="hiw-white-btn">
              Start My Free Assessment
            </Link>
            
            <p style={{fontSize: '0.9rem', color: '#cce5ff', marginTop: '20px', fontWeight: '500'}}>
                3 Free Credits included. No credit card required. GDPR Ready.
            </p>
          </div>

        </div>
      </header>
      <Footer />
    </div>
  );
}

export default HowItWorksPage;